import React, { useEffect, useState } from "react";
import { Tooltip, OverlayTrigger, Card } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { default as Select, components }  from "react-select";
import $ from "jquery";
import * as ReactDOM from 'react-dom';
import "datatables.net";
import {getFilenameFromURL,getUsername,formatDate} from "../../utils/common_functions"
import {API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE} from "../../utils/config_mapping"
import CommonIcon from '../common/customicon';
import PageLoader from '../common/pageloader';
import ProcessLoader from '../common/processloader';
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.css";
import {getAllTaxonomy,createTaxonomy,deleteTaxonomy,updateTaxonomy, getAllClauses} from "../../services/admin"
import Message from "../common/message";
// import ReactJson from 'react-json-view';

const taxonomies_options = [
  { value: 'SalesForce', label: 'SalesForce' },
  { value: 'Adobesign', label: 'Adobesign' },
  { value: 'SignNow', label: 'SignNow' },
  { value: 'Docusign', label: 'Docusign' },
];

export const Notification = () => {
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const [addclausemodal, setAddClausesModal] = useState(false);
  const [clausesData, setClausesData] = useState([]); // Clause options
  const handleClose = () => setAddClausesModal(false);
  const handleShow = () => setAddClausesModal(true);

  const [promptmodal, setAddPromptModal] = useState(false);
  const handlePromptClose = () => setAddPromptModal(false);
  const handlePromptShow = () => setAddPromptModal(true);

  const [deletedocumentmodal, setDeleteClausesModal] = useState(false);
  const handleDeleteClose = () => setDeleteClausesModal(false);
  const handleDeleteShow = () => setDeleteClausesModal(true);
  const [loading, setLoading] = useState(true); // State to track loading
  const [data, setData] = useState([]); // State to hold API data

  const [prompt_data
    , setPromptData] = useState([]); // State to hold API data


  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterTextClauses, setFilterTextClauses] = useState(""); // For clause filtering
  const [selectedClauses, setSelectedClauses] = useState([]); // Selected clauses
  const [filters, setFilters] = useState({
  filterstatus: null,
  filterTextSearch: ""
});

const initialState = {
    taxonomyName:"",
    taxonomyId:"",
    connectorName:"",
    connectorType:"",
    connectorOrganizationID:"",
    connectorAPIToken:"",
    connectorSecretKey:""
}

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

   const handleDelete = async (event) => {
      const dataId = event.target.getAttribute('data-id');
      const targetElement = document.getElementById("app_err");
      if(dataId){

        try {
            const result = await deleteTaxonomy(dataId);
            if(result!==undefined){
              if (result.code === API_SUCCESS_RESPONSE_CODE) {
                handleDeleteClose()
                fetchData();
                if (targetElement) {
                  ReactDOM.unmountComponentAtNode(targetElement);
                }
                ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
                
              }
            }
        } catch (error) {
          console.error("Error refreshing token:", error);
        }
      }
    };


  // Filter clauses based on the search text
  const filteredClauses = clausesData.filter((clause) =>
    clause.clauseName.toLowerCase().includes(filterTextClauses.toLowerCase())
  );

 // Handle individual clause selection (used for clicking on checkboxes manually)
const handleClauseSelection = (clause) => {
  setSelectedClauses(prevSelected => 
    prevSelected.includes(clause)
      ? prevSelected.filter(c => c !== clause) // Remove if already selected
      : [...prevSelected, clause] // Add to selected if not already there
  );
};


    const handleSaveConnector = async (pmData) => {
        const targetElement = document.getElementById("app_err");
        if(pmData.taxonomyId===""){
          const result = await createTaxonomy(pmData);
          if (result.code === API_SUCCESS_RESPONSE_CREATED_CODE) {
            fetchData();
            handleClose()
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
           
          } else {
            console.warn("Unexpected response status:", result.status);
          }
        }else{
          const result = await updateTaxonomy(pmData.taxonomyId,pmData);
          if (result.code === API_SUCCESS_RESPONSE_CODE) {
            fetchData();
            handleClose()
            if (targetElement) {
              ReactDOM.unmountComponentAtNode(targetElement);
            }
            ReactDOM.render(<Message type='success' message={result.data.message} />, targetElement);
          } else {
            console.warn("Unexpected response status:", result.status);
          }
        }
    };

    const fetchData = async () => {
      $(".page_pro_load").hide();
      setLoading(true); // Stop loading spinner
      try {
        const result = await getAllTaxonomy();
        if (result.code === API_SUCCESS_RESPONSE_CODE) {
          setData(result.data);
          setFilteredData(result.data); // Set initial data for filtering
        } else {
          console.warn("Unexpected response status:", result.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      finally {
         setLoading(false); // Stop loading spinner
     }
    };
 useEffect(() => {
      fetchData();
 }, []); // Empty dependency array ensures this runs only once

const [selectAll, setSelectAll] = useState(false);

// Handle Select All functionality
const handleSelectAll = () => {
  if (selectAll) {
    // If "Select All" is already checked, unselect all clauses
    setSelectedClauses([]);
    setSelectAll(false);
  } else {
    // Select all currently filtered clauses
    const allFilteredClauses = filteredClauses.map(clause => clause.clauseName);
    setSelectedClauses(allFilteredClauses);
    setSelectAll(true);
  }
};


  // Handle individual clause selection (optional if needed)
  const handleClauseClick = (clause) => {
    setSelectedClauses(prevSelected =>
      prevSelected.includes(clause)
        ? prevSelected.filter(c => c !== clause)
        : [...prevSelected, clause]
    );
  };


 const fetchClauseData = async () => {
  try {
    const result = await getAllClauses();
    if (result.code === API_SUCCESS_RESPONSE_CODE) {
      setClausesData(result.data);
    } else {
      console.warn("Unexpected response status:", result.status);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
 }

 useEffect(() => {
  fetchClauseData();
}, []); // Empty dependency array ensures this runs only once

  useEffect(() => {
    if (filteredData.length > -1) {
      const table = $("#contract_grid").DataTable({
        createdRow: function(row, data, dataIndex) {
          if (data.length === 1) {
              $(row).addClass('empty-row');
          }
          },
        scrollCollapse: true,
        scrollX: true,
        pageLength: 25, // Set default number of records per page
       // scrollY:$(window).height()-($("#table_height").height()+180),
        data: filteredData,
        destroy: true, // Ensure the previous table is destroyed
        order: [],  // This disables default sorting on any column
        columnDefs: [
          { 
            targets: [3], // Center-align "Created By" column
            className: 'text-left' // Bootstrap's text-center class
          },
          { 
            targets: [4], // Center-align "Created By" column
            className: 'text-center' // Bootstrap's text-center class
          },
          { 
            targets: '_all', // Left-align all other columns
            className: 'text-left' // Bootstrap's text-left class
          }
        ],
        columns: [
          { data: "taxonomyName", title: "Connector Name",width: "200px", },
          { data: "taxonomyType", title: "Type",width: "100px", },
          
          { data: "createdBy", title: "Created By",width: "150px", },
          {
            data: "createdAt", // Field name from your data
            title: "Created At",
           // width: "150px",
            render: function (data, type, row) {
              return data;
            }},
            { data: "clauses", title: "Clauses",width: "100px", 
            render: function (data, type, row) { 
            if(data){
              let clause_len = data.length;
              return '<div class="">'+clause_len+'</div>'
              }else{ return '<div class="">0</div>'} } 
          },
          {
            title: "Actions",
            orderable: false, // Disable sorting for this column
            data: null,
            width: "60px", 
            createdCell: function (td, cellData, rowData, row, col) {
              // Clear the default HTML and replace it with React-rendered content
              ReactDOM.render(
                <>

<OverlayTrigger
                    placement="top"
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    overlay={<Tooltip id="view-top">Prompt</Tooltip>}
                  >
                    <a href="javascript:void(0);" className="showprompt-btn" data-rowdata={JSON.stringify(rowData)}>
                      <i className="datatable-edit-icon"></i>
                    </a>
                  </OverlayTrigger>
                  &nbsp;
                  <OverlayTrigger
                    placement="top"
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    overlay={<Tooltip id="view-top">Edit</Tooltip>}
                  >
                    <a href="javascript:void(0);" className="view-btn" data-rowdata={JSON.stringify(rowData)}>
                      <i className="datatable-pencil-icon"></i>
                    </a>
                  </OverlayTrigger>
                  &nbsp;
                  <OverlayTrigger
                    trigger={['hover', 'click']} // Add 'click' to ensure it closes on click
                    placement="top"
                    overlay={<Tooltip id="delte-top">Delete</Tooltip>}
                  >
                  <a href="javascript:void(0);" className="delete-btn" data-bs-toggle="modal"
                     data-bs-target="#confirmationModal" data-id={rowData._id} data-name={rowData.taxonomyName}>
                    <i className="datatable-delete-icon"></i>
                  </a></OverlayTrigger>
                  &nbsp;
                </>,
                td // Render the content directly into the table cell
              );
            }
          }
                 ],
        fixedColumns: {
          start: 1,
          end: 1
      },
        paging: true,
        searching: false,
        ordering: true,
        responsive: true,
        fixedHeader: true,
        language: {
          emptyTable: "No data found matching the filters",  // Custom message for no data
        },
      });

      $('.menu-icon').on('click', function() {
        // Adjust DataTable columns and redraw when the sidebar menu is toggled
        setTimeout(function() {
          table.columns.adjust().draw();
        }, 100); // Adjust the delay time based on your sidebar transition duration
      });


      $("#contract_grid").on("click", ".showprompt-btn", function () {
        const rowData = $(this).data("rowdata");
        setAddPromptModal(true); // Open the modal
        console.log(rowData.prompt)
        setPromptData(rowData.prompt)
      });


      $("#contract_grid").on("click", ".view-btn", function () {
        const rowData = $(this).data("rowdata");
        setFormData({
          taxonomyName: rowData.taxonomyName,
          taxonomyType: taxonomies_options.find(option => option.value === rowData.taxonomyType),
         // taxonomyType: taxonomies_options.find(option => option.value === rowData.taxonomyType),
          taxonomyId: rowData._id,
          clauses: rowData.clauses || [], // If clauses exist
        });
        setSelectedClauses(rowData.clauses.map(clause => clause.clauseName)); // Prefill the selected clauses
        handleShow(); // Open the modal
      
      });

      $("#contract_grid").on("click", ".delete-btn", function () {
        handleDeleteShow()
        const id = $(this).data("id");
        const name = getFilenameFromURL($(this).data("name"));
        setTimeout(function() {
          $("#btn_delete").attr("data-id", id);
          $("#document_name").html(name);
        }, 200);
       });

      return () => {
        table.destroy(); // Clean up DataTable instance
      };
    }
  }, [filteredData]);

    // Search handler
    const handleSearch = (e) => {
      setSearchQuery(e.target.value);
      applyFilters(e.target.value, filters);
    };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.taxonomyName) newErrors.taxonomyName = "Connector name  is required.";
    if (!formData.taxonomyType) newErrors.taxonomyType = "Connector type  is required.";
    if (selectedClauses.length === 0) newErrors.Associatedclauses = "Associated clauses  is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const handleSelectChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      taxonomyType: selectedOption  // Store the entire selected options array for multi-select
    }));
    setErrors((prevErrors) => ({ ...prevErrors, taxonomyType: "" })); // Clear error if any
  };
  

  const resetForm = (e) => {
    handleShow()
    setFormData(initialState); // Reset form fields to initial state
    setSelectedClauses([]); // Clear selected clauses
  }

  const handleSubmit = (e) => {
    const logged_user_name = getUsername();
    e.preventDefault();
    if (!validateForm()) return;
    $(".page_pro_load").show();
    if(selectedClauses.length > 0){
      formData.clauses = selectedClauses.map(item => ({ clauseName: item }));
      formData.taxonomyType = formData.taxonomyType.value
     // handleSaveTaxonomy(formData)
    }
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prevState) => {
      const newFilters = { ...prevState, [filterName]: value };
      applyFilters(newFilters);
      return newFilters;
    });
  };

  const applyFilters = (newFilters) => {
    let filteredDataTemp = data;
    if (newFilters.filterTextSearch) { // New filter for text search
      filteredDataTemp = filteredDataTemp.filter((doc) => 
        doc.taxonomyName.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.taxonomyType.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.createdBy.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase()) ||
        doc.createdAt.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())  ||
        doc._id.toLowerCase().includes(newFilters.filterTextSearch.toLowerCase())
      );
    }
    setFilteredData(filteredDataTemp);
  };

  const resetFilters = () => {
    setSearchQuery('');
    setFilters({
      filterdocumentType: null,
      filterlicensor: null,
      filterexpiryDate: '',
      filterstatus: null
    });
    setFilteredData(data); // Reset to full data
  };


  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
          <div className="flex-grow-1" id="row_heading">
            <div className="page-title">Connectors</div>
            <p className="text-muted my-2 ff-secondary">
            Manage and organize standard Connectors
            </p>
            <div id="app_err"></div>
          </div>
          { data.length > 0 ? 
          <div className="row g-2 mb-4 mt-4" id="row_search">
            <div className="col-sm-9">
              <div className="search-box">
                <input
                  type="text"
                  className="form-control"
                  id="searchClausess"
                  placeholder="Search Connectors..."  // This should work as expected
                  onChange={(e) => handleFilterChange('filterTextSearch', e.target.value)}
                />
                <i className="grid-search">
                <CommonIcon iconName="Search" size={"14px"}  />
                </i>
              </div>
            </div>
            <div className="col-sm-auto ms-auto">
              <div className="list-grid-nav hstack gap-1">
                <button className="btn btn-light" onClick={fetchData}>
                <CommonIcon iconName="RefreshCw" size={"14px"} color={"#000"} />
                </button>
                <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Plus" size={"14px"} color="#fff" /> Add Connector
                </button>
              </div>
            </div>
          </div> :"" }

      <div className="row d-none" id="row_filter" >
      <div className="col-lg-1 mt-2">
      <CommonIcon iconName="Filter" size={"14px"}  /> Filters:
      </div>
      <div className="col-lg-3">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterdocumentType}
            onChange={(selectedOption) => handleFilterChange('filterdocumentType', selectedOption)}
            options={documentTypeOptions}
            placeholder="Clauses Type"
          /> */}
      </div>

      <div className="col-lg-3">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterlicensor}
            onChange={(selectedOption) => handleFilterChange('filterlicensor', selectedOption)}
            options={licensorOptions}
            placeholder="Licensor"
          /> */}
      </div>
      <div className="col-lg-3 mb-2">
      {/* <Select
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option
            }}
            value={filters.filterstatus}
            onChange={(selectedOption) => handleFilterChange('filterstatus', selectedOption)}
            options={statusoptions}
            placeholder="Status"
          /> */}
          </div>
      </div>
      </div>
          <div className="row">
            <div className="col-lg-12">
                  <div>
                    {/* DataTable */}
                    {loading ? (
                 <PageLoader />
            ) :  data.length > 0 ?
                (
                <div className="row  mt-4">
                  <div className="col-lg-12">
                    <table
                      id="contract_grid"
                      className="display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                      </thead>
                    </table>
                  </div>
                </div>) :     <div className="mt-5 card"><div className="text-center">
      <div className="no-doc-container my-4">
        {/* Bootstrap file-earmark icon with a warning sign */}
        <CommonIcon iconName="Database" width="50" height="50" />
        <div className="mt-3">
          <i className="bi bi-exclamation-circle-fill text-danger"></i>
        </div>
      </div>
      <h4 className="text-muted mb-4">No Connector Found</h4>

      <button onClick={resetForm}
                  className="btn btn-primary uploadcontract-modal mb-4"
                  data-bs-toggle="modal"
                  data-bs-target="#addmemberModal"
                >
                  <CommonIcon iconName="Plus" size={"14px"} color="#fff" /> Add Connector
                </button>
                <br/>
                <br/>
    </div>
    </div>
 }
                  </div>
                </div>
              </div>
        </div>
      </div>

      <Modal show={deletedocumentmodal} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title><div className="page-title" id="confirmationModalLabel">
                Delete
              </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label class="form-label">Are you sure want to delete <span id="document_name"></span> taxonomy?</label>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleDeleteClose} className="btn btn-light" data-bs-dismiss="modal"><CommonIcon iconName="X" size={"14px"} /> Close</button>
                  <button onClick={handleDelete} id="btn_delete" data-id="1111" type="submit" className="btn btn-primary">
                    <CommonIcon iconName="Trash" size={"14px"} color="#fff" /> Delete
                  </button>
        </Modal.Footer>
      </Modal>



      <Modal show={promptmodal} onHide={handlePromptClose}>
        <Modal.Header closeButton>
          <Modal.Title><div className="page-title" >
                Prompt
              </div></Modal.Title>
              <p className="modal-desc">
                      View system prompt and user prompt
            </p>

        </Modal.Header>
        <Modal.Body>
          <br/>
          <br/>
        <pre className="bg-light p-3 rounded" style={{height:"200px"}}>
        {JSON.stringify(prompt_data, null, 4).replace(/\n/g, '')}
        {/* <ReactJson
        src={prompt_data}
        theme="monokai" // You can choose different themes
        collapsed={false} // Expand all by default
        displayDataTypes={false} // Hide data types
      /> */}

         </pre>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>

      


      <Modal show={addclausemodal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> 
                  {formData.taxonomyId==="" ? "Create New Connector" : "Edit Connector"}
           </Modal.Title>
           <p className="modal-desc">
           {formData.taxonomyId==="" ? "Add a new connector" : "Edit a connector"}
            </p>
        </Modal.Header>
        <Modal.Body>
        <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-lg-12">
                    <label className="form-label">Connector Name</label>
                    <input type="hidden" name="taxonomyId" value={formData.taxonomyId} />
                    <input
                      type="text"
                      name="taxonomyName"
                      className="form-control"
                      value={formData.taxonomyName}
                      onChange={handleInputChange}
                      placeholder="Enter clause name"
                    />
                    {errors.taxonomyName && <div className="text-danger">{errors.taxonomyName}</div>}
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">Connector Type</label>
                    {console.log(formData)}
                    <Select
                        name="taxonomyType"
                        options={taxonomies_options}
                        value={formData.taxonomyType}
                        onChange={handleSelectChange}
                        placeholder="Select a Connector Type"
                      />
                    {errors.taxonomyType && <div className="text-danger">{errors.taxonomyType}</div>}
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">Organization ID</label>
                    <input type="hidden" name="taxonomyId" value={formData.taxonomyId} />
                    <input
                      type="text"
                      name="connectorOrganizationID"
                      className="form-control"
                      value={formData.connectorOrganizationID}
                      onChange={handleInputChange}
                      placeholder="Enter clause name"
                    />
                    {errors.connectorOrganizationID && <div className="text-danger">{errors.connectorOrganizationID}</div>}
                  </div>


                  <div className="col-lg-12">
                    <label className="form-label">API Token</label>
                    <input type="hidden" name="taxonomyId" value={formData.taxonomyId} />
                    <input
                      type="text"
                      name="connectorAPIToken"
                      className="form-control"
                      value={formData.connectorAPIToken}
                      onChange={handleInputChange}
                      placeholder="Enter clause name"
                    />
                    {errors.connectorAPIToken && <div className="text-danger">{errors.connectorAPIToken}</div>}
                  </div>


                  <div className="col-lg-12">
                    <label className="form-label">Secret Key</label>
                    <input type="hidden" name="taxonomyId" value={formData.taxonomyId} />
                    <input
                      type="text"
                      name="connectorSecretKey"
                      className="form-control"
                      value={formData.connectorSecretKey}
                      onChange={handleInputChange}
                      placeholder="Enter clause name"
                    />
                    {errors.connectorSecretKey && <div className="text-danger">{errors.connectorSecretKey}</div>}
                  </div>
                <div className="page_pro_load">{
                <ProcessLoader pmMessage={"PDF upload in progress, please wait..."}  />
                }</div>
                <div id="uploaderror"></div>
                </div>
              </form>
            </div>
        </Modal.Body>
        <Modal.Footer>
        <button type="button" onClick={handleClose} className="btn btn-light" data-bs-dismiss="modal"><i className="ri-close-line align-bottom me-1"></i> Close</button>
              <button onClick={handleSubmit} type="submit" className="btn btn-primary">
                    {formData.taxonomyId==="" ? "Create Connector" : "Update Connector"}
               </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};